import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PackageFormValues } from '@/views/add-package/add-package.types';
import UploadedImagesGrid from '../../../AssetsStep/UploadedImagesGrid';
import { PreviewSectionCard } from '../PreviewSectionCard';

const AssetsSection = () => {
    const { control } = useFormContext<PackageFormValues>();
    const images = useWatch({
        control,
        name: 'assets.images',
        defaultValue: [],
    });

    return (
        <PreviewSectionCard title="Assets">
            {images?.length ? (
                <UploadedImagesGrid images={images} readOnly />
            ) : (
                <Typography variant="body2">—</Typography>
            )}
        </PreviewSectionCard>
    );
};

export default AssetsSection;
